import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import API from '../api/axios';

const FALLBACK_MENUS = [
  { id: 1, parent_id: 0, sort_order: 1, title: 'Home', slug: 'home', url: '/', target: '_self' },
  { id: 2, parent_id: 0, sort_order: 2, title: 'About us', slug: 'about', url: '/about-us', target: '_self' },
  { id: 21, parent_id: 2, sort_order: 1, title: 'About St. Andrews Group', slug: 'about-standrews-group', url: '/about-standrews-group', target: '_self' },
  { id: 22, parent_id: 2, sort_order: 2, title: 'About St. Andrews', slug: 'about-us', url: '/about-us', target: '_self' },
  { id: 23, parent_id: 2, sort_order: 3, title: 'Why us', slug: 'why-us', url: '/why-us', target: '_self' },
  { id: 24, parent_id: 2, sort_order: 4, title: 'Core Values', slug: 'core-values', url: '/core-values', target: '_self' },
  { id: 3, parent_id: 0, sort_order: 3, title: 'Academics', slug: 'academics', url: '#', target: '_self' },
  { id: 301, parent_id: 3, sort_order: 1, title: 'Curriculum', slug: 'curriculum', url: '/curriculum', target: '_self' },
  { id: 305, parent_id: 3, sort_order: 2, title: 'Infrastructure', slug: 'infrastructure', url: '/infrastructure', target: '_self' },
  { id: 302, parent_id: 3, sort_order: 3, title: 'Extra-Curricular Activities', slug: 'extra-curricular-activities', url: '/extra-curricular-activities', target: '_self' },
  { id: 303, parent_id: 3, sort_order: 4, title: 'Other Facilities', slug: 'other-facilities', url: '/other-facilities', target: '_self' },
  { id: 304, parent_id: 0, sort_order: 5, title: 'Gallery', slug: 'gallery', url: '/gallery', target: '_self' },
  { id: 4, parent_id: 0, sort_order: 4, title: 'Admission', slug: 'admission', url: '/admission', target: '_self' },
  { id: 5, parent_id: 0, sort_order: 6, title: 'Blog', slug: 'article', url: '/article', target: '_self' },
  { id: 6, parent_id: 0, sort_order: 7, title: 'Contact', slug: 'contact', url: '/contact-us', target: '_self' },
  { id: 61, parent_id: 6, sort_order: 1, title: 'Contact us', slug: 'contact-us', url: '/contact-us', target: '_self' },
  { id: 62, parent_id: 6, sort_order: 2, title: 'Job Application Form', slug: 'job-application-form', url: '/job-application-form', target: '_self' },
];

const SCHOOLS = [
  { name: 'Gurugram', url: 'https://www.sawsgurugram.com/' },
  { name: 'Vasundhara', url: 'https://sawsvasundhara.com/' },
  { name: 'Indirapuram', url: 'https://www.sawsindirapuram.com/' },
  { name: 'Dehradun', url: 'https://www.sawsdehradun.in/' },
  { name: 'Siddharth Vihar', url: 'https://sawssiddharthvihar.in/' },
  { name: 'Little Andrews', url: 'http://littleandrews.in/' },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubMenus, setOpenSubMenus] = useState({});
  const [menus, setMenus] = useState([]);
  const [settings, setSettings] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [schoolOpen, setSchoolOpen] = useState(false);
  const schoolRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1023px)');
    setIsMobile(mq.matches);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [menuRes, settingRes, contactRes] = await Promise.all([
          API.get('/menus/public'),
          API.get('/settings/public'),
          API.get('/contacts/public'),
        ]);
        setMenus(menuRes.data.data || []);
        const s = settingRes.data.data || {};
        const c = contactRes.data.data || {};
        setSettings({ ...s, ...c });
      } catch (err) { console.error(err); }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (schoolRef.current && !schoolRef.current.contains(e.target)) setSchoolOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (!menuOpen) setOpenSubMenus({});
  }, [menuOpen]);

  useEffect(() => {
    setOpenSubMenus({});
  }, [location.pathname]);

  const isActive = (slug) => {
    const path = location.pathname;
    if (slug === 'home' && path === '/') return true;
    return path === `/${slug}` || path.startsWith(`/${slug}/`);
  };

  const effectiveMenus = menus.length ? menus : FALLBACK_MENUS;
  const topMenus = effectiveMenus.filter(m => m.parent_id === 0).sort((a, b) => a.sort_order - b.sort_order);

  const getChildren = (parentId) =>
    effectiveMenus.filter(m => m.parent_id === parentId).sort((a, b) => a.sort_order - b.sort_order);

  const toggleSubMenu = (id, force) => {
    setOpenSubMenus(prev => ({ ...prev, [id]: force !== undefined ? force : !prev[id] }));
  };

  const renderMenu = (items, depth = 0, parentId = null) => (
    <ul className={
      depth === 0
        ? 'flex flex-col lg:flex-row lg:items-center lg:justify-center text-left'
        : depth === 1
          ? 'lg:absolute lg:left-0 lg:top-full bg-[#1b3160] shadow-lg z-50 lg:min-w-[220px] w-full py-1 sub-menu text-left' +
            (depth > 0 && parentId && openSubMenus[parentId] ? ' open' : '')
          : 'lg:absolute lg:left-full lg:top-0 bg-[#1b3160] shadow-lg z-50 lg:min-w-[220px] w-full py-1 sub-menu text-left' +
            (depth > 0 && parentId && openSubMenus[parentId] ? ' open' : '')
    }
    >
      {items.map(menu => {
        const children = getChildren(menu.id);
        const hasChildren = children.length > 0;
        return (
          <li key={menu.id} className="relative"
            onMouseEnter={() => { if (hasChildren) toggleSubMenu(menu.id, true); }}
            onMouseLeave={() => { if (hasChildren) toggleSubMenu(menu.id, false); }}
          >
            <div className="flex items-center justify-between">
              <Link to={menu.url || '#'}
                    className={`flex-1 block px-4 py-3 text-white text-[15px] capitalize font-menu font-semibold hover:bg-white/10 transition-colors ${isActive(menu.slug) ? 'bg-white/10' : ''}`}
                    onClick={(e) => {
                      if (!menu.url || menu.url === '#') {
                        e.preventDefault();
                        if (hasChildren) toggleSubMenu(menu.id);
                        return;
                      }
                      if (!hasChildren) setMenuOpen(false);
                    }}
                    target={menu.target}>
                {menu.title}
              </Link>
              {hasChildren && (
                <button onClick={(e) => { e.preventDefault(); toggleSubMenu(menu.id); }}
                        className={`px-3 py-2.5 text-white/60 hover:text-white hover:bg-white/10 transition-colors text-xs lg:hidden`}
                        aria-label="Toggle submenu">
                  <i className={`fas fa-chevron-${openSubMenus[menu.id] ? 'down' : 'right'} transition-transform`}></i>
                </button>
              )}
            </div>
            {hasChildren && renderMenu(children, depth + 1, menu.id)}
          </li>
        );
      })}
    </ul>
  );

  return (
    <>
      {/* Top Bar */}
      <div className="bg-[#1b3160] text-white/80 py-2 text-sm relative z-[60]">
        <div className="container flex items-center justify-between">
          <div className="hidden md:flex items-center gap-4">
            {(() => {
              const phones = (settings.phone || '+91-9266333940 | +91-9266333941').split(/[,|]/).map(p => p.trim()).filter(Boolean);
              return phones.map((p, i) => (
                <a key={i} href={`tel:${p.replace(/[^0-9+]/g, '')}`} className="hover:text-white transition-colors"><i className="fas fa-phone-alt mr-1"></i> {p}</a>
              ));
            })()}
            <a href={`mailto:${settings.email || 'info@sawssonipat.com'}`} className="hover:text-white transition-colors"><i className="fas fa-envelope mr-1"></i> {settings.email || 'info@sawssonipat.com'}</a>
          </div>
          <div className="flex items-center gap-6 w-full md:w-auto justify-between md:justify-end">
            <div className="md:hidden flex items-center gap-4">
              <a href={`tel:${(settings.phone || '+91-9266333940').split(/[,|]/)[0].trim().replace(/[^0-9+]/g, '')}`} className="text-white/85 hover:text-white transition-colors" aria-label="Call"><i className="fas fa-phone"></i></a>
              <a href={`mailto:${settings.email || 'info@sawssonipat.com'}`} className="text-white/85 hover:text-white transition-colors" aria-label="Email"><i className="fas fa-envelope"></i></a>
            </div>
            <div className="flex gap-3 items-center">
              <a href="https://www.facebook.com/share/1LWoXSJynp/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="https://www.instagram.com/saws.sonipat?igsh=MXNzbGd4eWNpZXRmeA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="https://youtube.com/@sawssonipat?si=Kn-dJOGMkaDYdsQX" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
            </div>
            <div className="relative" ref={schoolRef}>
              <button
                onClick={() => setSchoolOpen(!schoolOpen)}
                onMouseEnter={() => !isMobile && setSchoolOpen(true)}
                className="hover:text-white transition-colors flex items-center gap-1.5"
              >
                Other Branches <i className={`fas fa-chevron-${schoolOpen ? 'up' : 'down'} text-[10px]`}></i>
              </button>
              {schoolOpen && (
                <div
                  className="absolute right-0 top-full mt-1 bg-white shadow-xl rounded-lg py-1 min-w-[200px] z-[70] border border-gray-100"
                  onMouseLeave={() => !isMobile && setSchoolOpen(false)}
                >
                  {SCHOOLS.map((s) => (
                    <a
                      key={s.name}
                      href={s.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2.5 text-sm text-body hover:bg-primary/5 hover:text-primary transition-colors"
                    >
                      {s.name}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white border-b border-gray-100 py-3 sticky top-0 z-50">
        <div className="container">
          <div className="flex items-center gap-4">
            <Link to="/" className="flex items-center gap-3">
              <img src="/images/logo-sonipat.png" className="h-[3.6rem] sm:h-[4.5rem] w-auto max-w-[240px] sm:max-w-none"
                   alt={settings.site_name || 'St. Andrews World School'} />
              <span className="hidden md:block h-8 md:h-10 w-px bg-gray-300" aria-hidden="true"></span>
              <img src="/images/cambridge-logo.jpeg" className="hidden md:block h-[3.5rem] w-auto"
                   alt="Cambridge" />
            </Link>
            <div className="hidden lg:flex items-center gap-3 ml-auto">
              <button onClick={() => { if (typeof window.openEnquiryPopup === 'function') { window.openEnquiryPopup(); } else { const el = document.querySelector('.npfWidgetButton'); if (el) el.click(); } }} className="btn-primary">
                Apply Now <i className="fas fa-arrow-right ml-2 text-[12px]"></i>
              </button>
              <button onClick={() => navigate("/contact-us")} className="btn-outline !text-primary !border-gray-200 !bg-white hover:!bg-light">
                Contact Us
              </button>
            </div>
            <button className="lg:hidden ml-auto bg-primary text-white px-4 py-2 rounded-md focus:outline-none" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle Menu">
              <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <div className={`bg-[#1b3160] sticky top-[72px] z-40 ${menuOpen ? 'block' : 'hidden'} lg:block border-b border-white/10`}>
        <div className="container max-w-full flex justify-center">
          <nav className="relative main-nav">
            {renderMenu(topMenus)}
          </nav>
        </div>
      </div>

      {menuOpen && <div className="fixed inset-0 bg-black/40 z-30" onClick={() => setMenuOpen(false)} />}
    </>
  );
};

export default Header;
